import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowTriangleTop: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArrowTriangleTop"><Path d="M19.5 19.5H4.5L12 4.5L19.5 19.5Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconArrowTriangleTop;
